import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Periodo} from '../../services/calendario.service';

@Component({
  selector: 'app-selecionar-periodo',
  templateUrl: './selecionar-periodo.component.html',
  styleUrls: ['./selecionar-periodo.component.scss']
})
export class SelecionarPeriodoComponent {
  periodo: Periodo;

  constructor(
    private modalCtrl: ModalController
  ) {
  }

  fechar() {
    this.modalCtrl.dismiss();
  }

  getPeriodo(periodo) {
    this.periodo = periodo;
  }

  aplicar() {
    this.modalCtrl.dismiss({periodo: this.periodo});
  }

}
